<template>
	<div class="form-group">
		<div class="form-group">
			<label for="prompt">
				{{ lang.get('fields.form.prompt.label') }}
			</label>
			<textarea
				id="prompt"
				v-model="prompt"
				:placeholder="lang.get('fields.form.prompt.placeholder')"
				class="form-control"
			/>
			<input v-model="aiAgentConfigurationString" type="hidden" :name="fieldName" />
		</div>

		<div class="form-group">
			<button id="test-prompt" class="action-button" @click.stop.prevent="testPrompt">
				{{ lang.get('buttons.ai_agent.test_prompt') }}
			</button>
		</div>

		<div class="form-group">
			<label for="triggerSelector">
				{{ lang.get('fields.form.triggers.label') }}
			</label>
			<multiselect
				id="triggersSelector"
				name="triggers[]"
				:options="triggerOptions"
				:selected-options="selectedTriggers"
				id-property="value"
				:counter="false"
				:select-all="false"
				:filter="false"
				@selected="updateConfiguration('triggers', $event)"
			>
			</multiselect>
		</div>

		<div class="form-group">
			<label for="aiAgentSelector">
				{{ lang.get('fields.form.ai-agent.label') }}
			</label>
			<select-field
				id="aiAgentSelector"
				:value="selectedAiAgent"
				:items="aiAgentOptions"
				@selected="updateAiAgentConfigValue"
			></select-field>
		</div>

		<div class="form-group">
			<label for="contextSelector">
				{{ lang.get('fields.form.contexts.label') }}
			</label>
			<multiselect
				id="contextSelector"
				name="contexts[]"
				:options="contextOptions"
				:selected-options="selectedContexts"
				id-property="value"
				:counter="false"
				:select-all="false"
				:filter="false"
				@selected="updateConfiguration('contexts', $event)"
			>
			</multiselect>
		</div>
	</div>
</template>

<script>
import { Multiselect, SelectField } from 'vue-bootstrap';
import { useController } from '@/domain/services/Composer';
import { aiAgentConfiguratorController } from '@/lib/components/Fields/AIAgentFieldConfigurator.controller';

export default {
	inject: ['lang'],
	name: 'AiAgentFieldConfigurator',
	components: { SelectField, Multiselect },
	props: {
		configuration: {
			type: Object,
			default: () => ({}),
		},
		fieldName: {
			type: String,
			default: 'configuration',
		},
		contextOptions: {
			type: Array,
			required: true,
		},
		triggerOptions: {
			type: Array,
			required: true,
		},
		aiAgentOptions: {
			type: Array,
			required: true,
		},
	},
	setup: useController(aiAgentConfiguratorController, 'aiAgentConfiguratorController'),
};
</script>

<style scoped></style>
